import compileSymbols from '~/utils/compileSymbols';

var types = ['CREATE', 'UPDATE', 'CLEAR_ALL'];
export default compileSymbols(types, 'suggestions');
